export const SaleListingTeamLeadDashboardPermissions = {
  SaleListingTeamLeadDashboard : 
    {
      permissionsId:'2cb200a1-0ab8-4ed6-6832-08da421d6e99',
      permissionsName :'Sale Listing Team Lead Dashboard',
      componentsId:null,
      components:null , 
    }
} ;
